import { useCallback, useEffect, useState } from 'react';

import AgoraRTC from 'agora-rtc-sdk-ng';

import { useAppContext } from '@/app/AppContext';
import Button from '@/components/Button';

import IconCamera from '@/assets/icons/camera.svg?react';
import { EVENTS, gtag } from '@/lib/gtag';

export default function ButtonSwitchCamera() {
  const appState = useAppContext();

  const [cameras, setCameras] = useState<MediaDeviceInfo[]>([]);
  // Which way the camera points is tracked from this button, not read back from
  // getSettings(): mobile Safari reports 'environment' for a front camera, and
  // believing it un-mirrors the customer's own face — they move right and their
  // reflection goes left.
  const [facingMode, setFacingMode] = useState<VideoFacingModeEnum>('user');

  const toggleFacingMode = useCallback(() => {
    const newFacingMode = facingMode === 'user' ? 'environment' : 'user';
    setFacingMode(newFacingMode);
    appState.camera.changeDevice({ facingMode: newFacingMode });
    appState.setIsMainVideoMirrored(newFacingMode === 'user');

    gtag(EVENTS.CHANGE_DEVICE, { facingMode: newFacingMode });
  }, [appState, facingMode]);

  useEffect(function initCameras() {
    if (appState.camera.isPermissionGranted) {
      AgoraRTC.getCameras().then(setCameras, () => console.debug('Unable to access cameras'));
    }
  }, [appState.camera]);

  return (
    <Button
      disabled={cameras.length <= 1}
      title="Switch camera"
      onClick={toggleFacingMode}
      className="mx-1"
      variant="info"
      size="icon">
      <IconCamera className="w-6 h-6" />
    </Button>
  );
}
